export function validLogin (value){
    return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$|^(\+7([0-9]){10})$/i.test(value) ? true : "Неверно введен телефон или email"
}
